import { SpinnerBox } from '@flipster/react/design-system/spinner';

const LoadingSpinner = () => {
  return <SpinnerBox size={40} css={{ h: 348, maxH: '100%' }} />;
};

export default LoadingSpinner;
